var dateUtils = {};

dateUtils.getLocalOffset = function () {
  var date = new Date();
  // Return local timezone offset in seconds
  return date.getTimezoneOffset() * (-60);
};

module.exports = dateUtils;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/util/date-utils.js
// module id = 1689
// module chunks = 6